import { render, staticRenderFns } from "./BalanceGifteryAccount.vue?vue&type=template&id=1630ac38&scoped=true"
import script from "./BalanceGifteryAccount.vue?vue&type=script&lang=js"
export * from "./BalanceGifteryAccount.vue?vue&type=script&lang=js"
import style0 from "./BalanceGifteryAccount.vue?vue&type=style&index=0&id=1630ac38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1630ac38",
  null
  
)

export default component.exports